module.exports = __webpack_public_path__ + "static/media/search.742e3062.svg";